import {Folder, Hot} from "./index";

export const Lotties = {
    hot: <Hot/>,
    folder: <Folder/>
}